import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import {getSurface} from '../actions/surfaceActions';
import PropTypes from 'prop-types';
import {APP_TITLE} from '../constants/config';
import { Helmet } from 'react-helmet';

class Categories extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return (
            <div id="categories">
                <Helmet>
                    <title>Product Options | {APP_TITLE}</title>
                </Helmet>
                <h2 className="entry-title"><small>Your {this.props.surface.name} surface</small><br />Product Options</h2>

                <div className="row entry">
                    {this.props.categories.map((b, i) =>
                        <div key={i} className="col-12 col-lg-6">
                            <Link to={"/" + this.props.surface.slug + "/" + b.slug}>
                                <header className="py-3 px-4"><h3 className="m-0 text-uppercase">{i + 1}. {b.title}</h3></header>
                                <div className="py-3 px-4">
                                    <div className="entry-content d-flex align-items-center">
                                        <p>{b.description}</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        );
    }

}

// Maps state from store to props
const mapStateToProps = (state, props) => {

    return {
        // You can now say this.props.books
        surface: getSurface(props.params.floorSurface, state),
        categories: state.categories,
    };

};

Categories.propTypes = {
    surface: PropTypes.object,
    categories: PropTypes.array,
};

// Use connect to put them together
export default connect(mapStateToProps)(Categories);


// WEBPACK FOOTER //
// ./src/components/Categories.js